<template>
  <AppContainer justify-center>
    <EHeroContent
      :title="t(useTranslationPath(callerPath, 'header'))"
      :description="
        t(useTranslationPath(callerPath, 'description'), {
          site: siteName,
          count: workOrderCount,
        })
      "
      variant="success"
      icon="circle-check"
    >
      <template #action>
        <EButton
          v-if="workOrderCount > 0"
          :label="t(useTranslationPath(callerPath, 'viewWorkOrders'), { count: workOrderCount })"
          variant="secondary"
          @click="handleViewWorkOrders"
        />
      </template>
    </EHeroContent>

    <template #bottom>
      <EButton
        :label="t(useTranslationPath(callerPath, 'endVisit'))"
        block
        @click="handleEndVisit"
      />
    </template>
  </AppContainer>
</template>

<script setup>
import AppContainer from '@/components/AppContainer.vue'
import { useTranslationPath } from '@/composables/useTranslationPath.js'
import { useAppStore } from '@/stores/AppStore.js'
import { useAuthStore } from '@/stores/authenticated/AuthStore'
import { useWorkOrderStore } from '@/stores/authenticated/WorkOrderStore'
import { EButton, EHeroContent } from '@expansivefm/eds'
import { computed, onMounted, ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRouter } from 'vue-router'

const { t } = useI18n()

const router = useRouter()

const appStore = useAppStore()
const authStore = useAuthStore()
const workOrderStore = useWorkOrderStore()

const callerPath = 'views.authenticated.workOrders.checkout.success'

const workOrderCount = ref(0)
const siteName = computed(() => authStore.maintainableEntity.site_name)

onMounted(async () => {
  appStore.$patch({ showBackButton: false })

  await workOrderStore.fetchWorkOrders().then(({ meta }) => {
    workOrderCount.value = meta.page?.total ?? 0
  })
})

const handleEndVisit = () => {
  authStore.logout()

  router.push({ name: 'index' })
}

const handleViewWorkOrders = () => {
  router.push({
    name: 'work-order.index',
  })
}
</script>
